import React from "react";
import { RightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import Avatar from "react-avatar";

const ProfileButton = () => {
  let navigate = useNavigate();
  return (
    <div
      className="bg-white py-2 px-4 w-full  cursor-pointer"
      onClick={() => navigate("/app/home")}
    >
      <div className="flex justify-between">
        <div className="flex">
          <div>
            <Avatar
              name={"Ahmed"}
              size={35}
              textSizeRatio={1.75}
              className="rounded-md"
            />
          </div>
          <div className="pl-2">
            <div className="text-medium text-sm">{"Ahmed"}</div>
            <div className="text-xs text-regular text-gray-500">{"Admin"}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileButton;
